module.exports = __webpack_public_path__ + "static/media/bat.e786288c.png";